jQuery(document).ready(function ($) {

    $('.js-filter').on('click', get_posts);

    $('.js-filter-overview').on('change', redirect);

    $('.js-load-more').on('click', load_more);

    function get_posts() {

        var url = "/wp-json/pwc/get_posts/",
            $this = $(this);

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                'term': {
                    'term_id': $(this).attr('data-id'),
                    'taxonomy': $(this).attr('data-tax')
                },
                'post_type': $(this).parents('[data-type]').attr('data-type')
            },
            success: function (response) {
                $this.parents('.u-content-row').find('.js-filter').removeClass('is-active');
                $this.addClass('is-active').parents('.u-content-row').find('.js-output').html(response);

            }
        });
        return false;
    }

    function redirect() {

        var parent = $(this).parents('.c-filters'),
            fields = parent.find('select, input'),
            url = {};

        $.each(fields, function () {
            switch (true) {
                case $(this).is("select"):
                    if (!$(this).find('option:selected').prop('disabled')) {
                        url[$(this).attr('name').replace('_', '-')] = $(this).val();
                    }
                    break;
                case $(this).is("input"):
                    if ($(this).val()) {
                        url[$(this).attr('name')] = $(this).val();
                    }
                    break;
            }
        });

        window.location.href = parent.find('a').attr('href') + '?' + $.param(url);

        return false;
    }

    function load_more(){
        const $this = $(this);

        $.ajax({
            url: "/wp-json/pwc/load-more/",
            method: 'POST',
            data: {
                'post_type': $this.attr('data-type'),
                'page': $this.attr('data-page'),
                'filters':getUrlVars()
            },
            beforeSend:function(){
                $this.addClass('is-active');
            },
            success: function (response) {
                if(response.more){
                    $this.removeClass('is-active').attr('data-page', response.page);
                }else{
                    $this.parents('.load-more').remove();
                }
                $('.js-output').append(response.html);
            }
        });


        return false;
    }

    function getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    }

});